export enum SvgCardType {
    Lyspare = 'Lyspare',
    HjerteHender = 'HjerteHender',
    BaatSkade = 'BaatSkade',
    BilSkadet = 'BilSkadet',
    BagasjeFlyplass = 'BagasjeFlyplass',
    HusEnkelt = 'HusEnkelt',
    Innbo = 'Innbo',
    DyrHund = 'DyrHund',
    DyrKatt = 'DyrKatt',
    DyrHest = 'DyrHest',
    DyrHone = 'DyrHone',
    Samtykke = 'Samtykke',
    GruppeMennesker = 'GruppeMennesker',
    BedriftBygning = 'BedriftBygning',
}

const svgCardClass = (ikon: SvgCardType) => {
    switch (ikon) {
        case SvgCardType.Lyspare:
            return 'svg-card-icon--lyspare';
        case SvgCardType.HjerteHender:
            return 'svg-card--hand-shake';
        case SvgCardType.BaatSkade:
            return 'svg-card--baat-skade';
        case SvgCardType.BilSkadet:
            return 'svg-card--bil-skadet';
        case SvgCardType.BagasjeFlyplass:
            return 'svg-card--bagasje-flyplass';
        case SvgCardType.HusEnkelt:
            return 'svg-card--hus-enkelt';
        case SvgCardType.Innbo:
            return 'svg-card--innbo';
        case SvgCardType.DyrHund:
            return 'svg-card--hund';
        case SvgCardType.DyrKatt:
            return 'svg-card--katt';
        case SvgCardType.DyrHest:
            return 'svg-card--hest';
        case SvgCardType.DyrHone:
            return 'svg-card--hone';
        case SvgCardType.Samtykke:
            return 'svg-card--samtykke';
        case SvgCardType.GruppeMennesker:
            return 'svg-card--gruppe-mennesker';
        case SvgCardType.BedriftBygning:
            return 'svg-card--bedrift-bygning';
        default:
            return '';
    }
};

export default svgCardClass;
